<template>
  <div id="content-page" class="content-page">
    <div class="iq-top-navbar">
      <div class="iq-navbar-custom">
        <nav class="navbar navbar-expand-lg navbar-light p-0">
          <router-link :to="homeURL">
            <img v-if="defaultAvatarLogo" :src="fileLogo" class="top-logo" />
            <img v-else class="top-logo" v-bind:src="'data:image/jpeg;base64,' + fileLogo" />
          </router-link>
        </nav>
      </div>
    </div>
    <b-container fluid>
      <b-row>
        <b-col>
          <iq-card>
            <template v-slot:headerTitle class="w--100">
              <h4 class="card-title float-left title-typography-color">
                <i class="fas fa-file"></i>
                {{ $t("public.views.Pages.Recipe.title") }}
              </h4>
              <div class="text-right w-100">
                <b-button v-if="!recipe.validateAt" class="mr-2" style="right" variant="success"
                  @click="validateRecipe()">{{ $t("public.views.Pages.Recipe.validate") }}
                </b-button>
              </div>
            </template>
            <template v-slot:body>
              <b-alert v-if="recipe.validateAt" show variant="danger">
                La receta fue expedida el dia: {{ recipe.validateAt }}
              </b-alert>
              <div class="about-info m-0 p-0">
                <div class="row">
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.professional") }}:</h6>
                  </div>
                  <div class="col-12">
                    <b-avatar class="mr-2" v-bind:src="
                      recipe.professional.avatarUrl
                        ? recipe.professional.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    {{ recipe.professional.name }}
                    {{ recipe.professional.lastname }} ({{
                      recipe.professional.document
                    }})
                  </div>
                  <div class="col-12">
                    <h6>
                      {{
                        $t("public.views.Pages.Recipe.professionalMemberId")
                      }}:
                    </h6>
                  </div>
                  <div class="col-12">{{ recipe.professional.memberId }}</div>
                  <div class="col-12">
                    <h6>
                      {{ $t("public.views.Pages.Recipe.professionalPhone") }}:
                    </h6>
                  </div>
                  <div class="col-12">{{ recipe.professional.phone }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.patient") }}:</h6>
                  </div>
                  <div class="col-12">
                    <b-avatar class="mr-2" v-bind:src="
                      recipe.patient.avatarUrl
                        ? recipe.patient.avatarUrl +
                        '/' +
                        getAuthentication()
                        : ''
                    "></b-avatar>
                    {{ recipe.patient.name }} {{ recipe.patient.lastname }} ({{
                      recipe.patient.document
                    }})
                  </div>

                  <div class="col-12">
                    <h6>
                      {{ $t("public.views.Pages.Recipe.patientDocument") }}:
                    </h6>
                  </div>
                  <div class="col-12">{{ recipe.patient.document }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.patientMutua") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.patient.mutua }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.medicine") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.medicine }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.presentation") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.presentation }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.units") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.units }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.posology") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.posology }}</div>
                  <div class="col-12">
                    <h6>
                      {{ $t("public.views.Pages.Recipe.unitsPosology") }}:
                    </h6>
                  </div>
                  <div class="col-12">{{ recipe.unitsPosology }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.pattern") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.pattern }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.duration") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.duration }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.orderNumber") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.orderNumber }}</div>
                  <div class="col-12">
                    <h6>
                      {{ $t("public.views.Pages.Recipe.dispensationDate") }}:
                    </h6>
                  </div>
                  <div class="col-12">{{ recipe.dispensationDate }}</div>
                  <div class="col-12">
                    <h6>{{ $t("public.views.Pages.Recipe.comments") }}:</h6>
                  </div>
                  <div class="col-12">{{ recipe.comments }}</div>
                </div>
              </div>
            </template>
          </iq-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import organizationService from "../../services/organization";
import recipeService from "../../services/recipe";
import utilsService from "../../services/utils";

export default {
  name: "RecipePublic",
  mounted() {
    this.getLogoOrganization();
    this.getPdfByToken();
    this.getByToken();
  },
  data() {
    return {
      homeURL: {
        type: Object,
        default: () => ({ name: "public.singin" }),
      },
      file: "",
      defaultAvatarLogo: true,
      fileLogo: "",
      recipe: {},
    };
  },
  methods: {
    getAuthentication() {
      return localStorage.getItem('authorization');
    },
    validateRecipe() {
      let self = this;

      this.$awn.asyncBlock(
        recipeService.validateByToken(this.$route.query.token),
        (response) => {
          if (response) {
            self.recipe = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "recipeService.validateByToken",
            module: "view-pages-recipe",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              token: this.$route.query.token
            })
          });
        },
        " "
      );
    },
    async getByToken() {
      let self = this;

      this.$awn.asyncBlock(
        recipeService.getByToken(this.$route.query.token),
        (response) => {
          if (response) {
            self.recipe = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "recipeService.getByToken",
            module: "view-pages-recipe",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              token: this.$route.query.token
            })
          });
        },
        " "
      );
    },
    async getPdfByToken() {
      let self = this;

      this.$awn.asyncBlock(
        recipeService.getPdfByToken(this.$route.query.token),
        (response) => {
          if (response) {
            self.file = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "ecipeService.getPdfByToken",
            module: "view-pages-recipe",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              token: this.$route.query.token
            })
          });
        },
        " "
      );
    },
    async getLogoOrganization() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findLogo(this.$route.query.organization),
        (response) => {
          if (response) {
            self.getLogo(response.data);
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findLogo",
            module: "view-pages-recipe",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organization: this.$route.query.organization
            })
          });
        }
      );
    },
    getLogo(uuid) {
      let self = this;
      utilsService
        .getFile(uuid)
        .then((response) => {
          if (response) {
            self.defaultAvatarLogo = false;
            self.fileLogo = response.data.data;
          } else {
            self.defaultAvatarLogo = true;
            self.fileLogo = require("../../assets/images/logo.png");
          }
        })
        .catch(function (error) {
          self.defaultAvatarLogo = true;
          self.fileLogo = require("../../assets/images/logo.png");
        });
    },
  },
};
</script>
